import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorMessage from "components/reusable/ErrorMessage";
import OtpDialog from "components/reusable/OtpDialog";
import Toolbar from "components/Toolbar";
import AuthContext from "context/AuthContext";
import useToastContext from "hooks/useToastContext";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function TransferUsername() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [loading, setLoading] = useState(false);
  const [requestBody, setRequestBody] = useState({});

  const {user} = useContext(AuthContext);


  const [showOtpDialog, setShowOtpDialog] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const requestBody = {
        amount: data.amount,
        description: data.description,
        username: data.username,
        transferType: "username",
      };
      setRequestBody(requestBody);
      const res = await apiPost(pathObj.transferOTP, requestBody);
      if (res.data.success) {
        setShowOtpDialog(true);
      } else {
        notification.error(res.data.message);
      }
    } catch (err) {}
    setLoading(false);
  };

  return (
    <>
      <Toolbar title={t("TRANSFER_USERNAME")} showBackBtn={true} />
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col w-full justify-center items-center">
        <div className="mt-3 p-4 rounded-3xl h-full w-full md:w-[25rem]">
          <div className="mt-2 mx-2">
            <div className="text-lg font-medium  mt-5 mb-2">{t("USERNAME")}</div>
            <input
              type="text"
              id="username"
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
              onKeyDown={(e) => {
                e.target.value = e.target.value.trim();
              }}
              {...register("username", {
                required: t("REGISTER_USERNAME"),
              })}
              required
            />

            <div className="text-lg font-medium  mt-5 mb-2">{t("AMOUNT")}</div>
            <div className="bg-card p-4 rounded-lg">
              <div className="flex justify-start gap-3 items-center">
                <div className="font-medium text-lg text-white">{user.wallet_currency}</div>
                <input
                  type="number"
                  id="amount"
                  inputType="numeric"
                  className="inputform border-0 text-heading text-white font-medium text-sm rounded-base block w-full px-3 rounded-lg py-2.5 shadow-xs placeholder:text-body"
                  placeholder={t("AMOUNT_FIELD")}
                  onKeyDown={(e) => {
                    e.target.value = e.target.value.trim();
                  }}
                  {...register("amount", {
                    required: t("AMOUNT_EMPTY"),
                  })}
                  required
                />
              </div>
            </div>
            <ErrorMessage message={errors?.amount?.message} />

            <div className="text-lg font-medium  mt-5 mb-2">{t("DESCRIPTION")}</div>
            <input
              type="text"
              id="description"
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
              onKeyDown={(e) => {
                e.target.value = e.target.value.trim();
              }}
              {...register("description", {
                required: "",
              })}
            />

            <div className="w-full mt-[5rem]">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button className="btn btn_theme w-full text-white" type="submit">
                  {t("CONFIRM")}
                </button>
              )}
            </div>
          </div>
        </div>
      </form>

      {showOtpDialog && (
        <OtpDialog
          otpURL={pathObj.transferOTP}
          otpConfirmURL={pathObj.transferToUsername}
          body={requestBody}
          onSuccess={(message) => {
            navigate("/dashboard");
            notification.success(message || t("OPERATION_SUCCESS"));
          }}
          onClose={() => {
            setShowOtpDialog(false);
          }}
        />
      )}
    </>
  );
}

export default TransferUsername;
